export const ACTIVATE_TAB = 'ACTIVATE_TAB';
export const DEMO_FORM_SUBMITTED = 'DEMO_FORM_SUBMITTED';
